

const Label = ({children}) => {
    return <label className='block text-base text-gray-700 dark:text-gray-400'>{children}</label>
}

export default Label;